import { absoluteTime, formatTime } from "../data";
import { ProductionActionView } from "./ProductionActionView";
import { StandardActionView } from "./StandardActionView";
import { TransportActionView } from "./TransportActionView";
import { actionTypes } from "../data";
import { DraggableActionItem } from "./DraggableActionItem";

function Timeline({
  startTime, 
  totalTime, 
  planets, 
  timeline, 
  handleDelete, 
  handleMove, 
  changeSetProduction, 
  changeTransportAction, 
  handleToggleDeactivate,
  setDraggedItem,
  draggedItem,
  updatePreviewState,
  activePlanetId
}) {
    const onMoveAction = (planetId, id, direction) => {
      handleMove(planetId, id, direction);
    };
    const onDeleteAction = (planetId, id) => {
      handleDelete(planetId, id);
    };
    const onToggleDeactivate = (planetId, id) => {
      handleToggleDeactivate(planetId, id);
    };
    
    // Handle drag and drop movement
    const moveItem = (sourcePlanetId, sourceIndex, targetPlanetId, targetIndex, newAction = null) => {
      if (newAction) {
        // Adding a new action from planet display
        handleMove(targetPlanetId, -1, 'add', newAction, targetIndex);
      } else {
        // Moving an existing action
        if (sourcePlanetId === targetPlanetId) {
          // Moving within the same planet
          const direction = sourceIndex < targetIndex ? 'down' : 'up';
          handleMove(sourcePlanetId, sourceIndex, direction, null, targetIndex);
        } else {
          // Moving between planets
          handleMove(sourcePlanetId, sourceIndex, 'move', targetPlanetId, targetIndex);
        }
      }
    };
    
    const invalid = timeline.some((element) => element.valid === false);
    const header_bg = (invalid ? "bg-red-400" : "");
    //const totalTime = timeline.length > 0 ? timeline[timeline.length - 1].endTime : 0;
    // Filter planets to show only the active one or all if none is selected
    const displayPlanetIds = activePlanetId ? [activePlanetId] : Object.keys(planets);

    return (
      <section className="w-full h-full overflow-y-auto bg-gray-800 p-4">
        <div className="timeline h-full flex flex-col bg-gray-600 text-white rounded-t-lg">
          <div className="sticky top-0 bg-gray-700 p-3 z-10 rounded-t-lg">
            {/* Total Time Header */}
            <header className={"text-xl font-bold text-center text-gray-50" + header_bg}>
              Total Time: {formatTime(totalTime)}
            </header>
          </div>
          
          <div className="flex-1 overflow-y-auto p-4">
            {/* Actions List */}
            {displayPlanetIds.map((planetId) => {
              return (
              <div key={"timeline-"+planetId} className="mb-4">
                <ul className="space-y-2">
                  {timeline.filter((action) => (action.planetId == planetId && action.forceShow === true) || (action.planetId == planetId && (action.editable || action.type===actionTypes.TRANSPORT))).map((action, idx) => {
                    // Extract numerical index from action.index if it's a string
                    const actionIndex = typeof action.index === 'string' ? 
                      parseInt(action.index.split('.')[0]) : 
                      action.index;
                    
                    // Only make editable actions draggable
                    const actionView = action.displayType === undefined ? 
                      (<StandardActionView key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      action.displayType === 'SET_PROD' ?
                      (<ProductionActionView showExtraWait={true} changeSetProduction={changeSetProduction} key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      action.displayType === 'TRANSPORT' ?
                      (<TransportActionView planets={planets} changeTransportAction={changeTransportAction} key={action.index} startTime={startTime} action={action} onMoveAction={onMoveAction} onDeleteAction={onDeleteAction} onToggleDeactivate={onToggleDeactivate} last={action.index === (timeline.length - 1)} />) :
                      null;
                    
                    return action.editable ? (
                      <DraggableActionItem 
                        key={action.index} 
                        index={actionIndex} 
                        planetId={action.planetId} 
                        moveItem={moveItem}
                        actionData={action}
                        setDraggedItem={setDraggedItem}
                        updatePreviewState={updatePreviewState}
                      >
                        {actionView}
                      </DraggableActionItem>
                    ) : (
                      <div key={action.index}>
                        {actionView}
                      </div>
                    );
                  })}
                </ul>
              </div>);
            })}
          </div>
        </div>
      </section>
    );
  }
  
  export default Timeline;